/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */
import { useEffect } from "react";

export function useOutsideClick(targetedRefs: any[], onClickOut: () => void){
  useEffect(() => {
    const onClick = ({target}: any) => targetedRefs.every(ref => ref.current && !ref.current.contains(target as Node))
      && onClickOut?.()
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [onClickOut, targetedRefs]);
}